import { render, staticRenderFns } from "./mobileGoogleAdsPopup.vue?vue&type=template&id=89cbcc16&scoped=true&"
import script from "./mobileGoogleAdsPopup.vue?vue&type=script&lang=js&"
export * from "./mobileGoogleAdsPopup.vue?vue&type=script&lang=js&"
import style0 from "./mobileGoogleAdsPopup.vue?vue&type=style&index=0&id=89cbcc16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cbcc16",
  null
  
)

export default component.exports